import { useEffect, useState } from "react";
import { Loader2, MapPinned, Search } from "lucide-react";
import { toast } from "sonner";
import { api, apiError } from "@/lib/api";

export const emptyTerritory = { areas: [], distributor_ids: [] };

export function territoryLabel(t) {
  const a = t?.areas?.length || 0;
  const d = t?.distributor_ids?.length || 0;
  if (!a && !d) return null;
  return [a && `${a} area`, d && `${d} distributor`].filter(Boolean).join(" · ");
}

export function TerritoryPicker({ value, onChange }) {
  const [opts, setOpts] = useState(null);
  const [q, setQ] = useState("");
  useEffect(() => { api.get("/users/territory-options").then((r) => setOpts(r.data.data)).catch((e) => toast.error(apiError(e))); }, []);
  const t = value || emptyTerritory;
  const has = (list, v) => list.some((x) => String(x).toLowerCase() === String(v).toLowerCase());
  const flip = (k, v) => {
    const list = t[k] || [];
    onChange({ ...t, [k]: has(list, v) ? list.filter((x) => String(x).toLowerCase() !== String(v).toLowerCase()) : [...list, v] });
  };
  const areas = (opts?.areas || []).filter((a) => a.toLowerCase().includes(q.toLowerCase()));

  return (
    <div className="territory-field" data-testid="territory-picker">
      <div className="territory-head"><MapPinned size={15} /><div><strong>Wilayah Supervisor</strong>
        <small>Supervisor hanya melihat outlet, order, kunjungan & dashboard di area/distributor terpilih. Kosong = mengikuti kolom Area.</small></div>
        <span className="territory-count" data-testid="territory-count">{territoryLabel(t) || "Belum dipilih"}</span></div>
      {!opts ? <div className="rj-loading"><Loader2 className="spin" /> Memuat wilayah…</div> : <>
        <div className="search-box territory-search"><Search /><input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Cari area / kota…" data-testid="territory-search" /></div>
        <div className="territory-chips">
          {areas.map((a) => (
            <button type="button" key={a} className={`territory-chip ${has(t.areas, a) ? "on" : ""}`} onClick={() => flip("areas", a)} data-testid={`territory-area-${a.toLowerCase().replace(/\s+/g, "-")}`}>{a}</button>
          ))}
          {areas.length === 0 && <span className="fin-muted">Tidak ada area yang cocok.</span>}
        </div>
        {opts.distributors.length > 0 && <>
          <small className="territory-sub">Distributor (outlet yang dilayani distributor ini ikut terlihat)</small>
          <div className="territory-chips">
            {opts.distributors.map((d) => (
              <button type="button" key={d.odoo_customer_id} className={`territory-chip dist ${has(t.distributor_ids, d.odoo_customer_id) ? "on" : ""}`}
                onClick={() => flip("distributor_ids", d.odoo_customer_id)} data-testid={`territory-dist-${d.odoo_customer_id}`}>{d.name}{d.area ? ` · ${d.area}` : ""}</button>
            ))}
          </div>
        </>}
      </>}
    </div>
  );
}
